// MoffAPI(actionのtype, reducerのstate)
export const LOADING: string = 'LOADING';
export const SUCCESS: string = 'SUCCESS';
export const ERROR: string = 'ERROR';

// ロコモ or ADL.
// ロコモ予防トレーニング.
export const LOCOMO_TYPE: number = 1;
// 日常生活動作トレーニング.
export const ADL_TYPE: number = 2;


// WEBPACK FOOTER //
// ./src/constants/MoffAPI.tsx